import HyperDiv from "components/ProjectNonSpecificComponents/Elements/HyperDiv/HyperDiv"
import React from "react"
import { IIconProps } from "./Icon/Interfaces"

const EmailIcon = ({ width = 21, height = 22, strokeColor = "var(--gray)" }: IIconProps) => {
	return (
		<HyperDiv width={width} height={height} centeredY>
			<svg width="24" height="18" viewBox="0 0 24 18" fill="none">
				<path
					d="M0 0V18H24V0H0ZM6.623 7.929L2 13.641V4.183L6.623 7.929ZM2.482 2H21.517L12 9.713L2.482 2ZM8.176 9.188L12 12.287L15.83 9.183L21.442 16H2.663L8.176 9.188ZM17.384 7.924L22 4.183V13.531L17.384 7.924Z"
					fill={strokeColor}
				/>
			</svg>
		</HyperDiv>
	)
}

export default EmailIcon
